import styled from "styled-components";

export default styled.div`
  display: flex;
  min-height: 41px;
  width: 100%;
  gap: 64px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 10px;
    height: 100%;
    width: 100%;
    .ssh-code {
      grid-column: 1 / span 2;
    }
  }
`;
